export default __webpack_public_path__ + "static/media/check.82d3eeba.svg";